import {z} from "zod"

import {postJson} from "../http"

const InitiateSetupResponseSchema = z.looseObject({
	Next: z.string().nonempty(),
	PaymentArrangementID: z.uuid(),
})

export type InitiateSetupResponse = z.infer<typeof InitiateSetupResponseSchema>

export async function initiateSetup({secureCode}: {secureCode: string}): Promise<InitiateSetupResponse> {
	const data = await postJson(`/app/payment-arrangement/${secureCode}`, InitiateSetupResponseSchema, {})
	return data
}
